/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("braddruleModule", []).
controller("braddruleCtrl", ["$scope", '$modalInstance', 'trsHttpService', "$document", "$timeout", "burstNewsRuleService", "item", "$validation", "modalDialog", function($scope, $modalInstance, trsHttpService, $document, $timeout, burstNewsRuleService, item, $validation, modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            pageNo: 0,
            pageSize: 10,
            wbSelect: true, //微博单选框
            wzSelect: true, //文章单选框
            hasId: false,
            brcontinue: true,
            way: true //渠道验证
        };
        $scope.data = {
            id: "", //规则id
            name: "", //规则名称
            content: "", //规则详情
            range: "", //规则范围，
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {}

    /**
     * [chooseWay description]  选择渠道
     * @param  {[type]} type [description] 0 微博   1网站
     * @return {[type]}      [description]
     */
    $scope.chooseWay = function(type) {
        !type ? $scope.status.wbSelect = !$scope.status.wbSelect : $scope.status.wzSelect = !$scope.status.wzSelect;
        if ($scope.status.wbSelect || $scope.status.wzSelect) {
            $scope.status.way = true;
        } else {
            $scope.status.way = false;
        }
    };
    /**
     * [brruletest description] 保存前验证
     * @return {[type]} [description]
     */
    $scope.brruletest = function() {
        $validation.validate($scope.AddRuleC).success(function() {
            //判断规则名称是否存在
            $scope.status.brcontinue = true;
            var params = {
                "typeid": 'screen',
                "serviceid": 'zjsentimentrulemgr',
                "modelid": 'getrulelist',
                "type": item.type,
                "search_word": '',
                "page_no": $scope.status.pageNo,
                "page_size": $scope.status.pageSize,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                if (data.content) {
                    for (var i = 0; i < data.content.length; i++) {
                        if (data.content[i].ruleName == $scope.data.name) {
                            modalDialog.alertType('', '已存在此名称的记录!', 'warning', 'confirm');
                            $scope.status.brcontinue = false;
                            return;
                        }
                    }
                }
                if ($scope.status.brcontinue == true) {
                    if ($scope.status.wbSelect && $scope.status.wzSelect) {
                        $scope.data.range = '0';
                    } else {
                        if ($scope.status.wbSelect == true) {
                            $scope.data.range = '1';
                        } else if ($scope.status.wzSelect == true) {
                            $scope.data.range = '2';
                        }
                    }
                    brrulesave();
                }
            });
        });


    };
    /**
     * [rulesave description] 保存
     * @return {[type]} [description]
     */
    function brrulesave() {
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentrulemgr',
            "modelid": 'saverule',
            "type": item.type,
            "name": $scope.data.name,
            "content": $scope.data.content,
            "range": $scope.data.range,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            modalDialog.alertType('', '添加成功！', 'success', false);
            $modalInstance.close(true);
        });
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.brcancel = function() {
        //如果标题或者内容有值调用窗口询问是否放弃
        if ($scope.data.name || $scope.data.content) {
            modalDialog.alertType('', '确定要放弃添加吗？', 'ask', true, function() {
                $modalInstance.dismiss();
            }, '');
        } else {
            $modalInstance.dismiss();
        }
    };
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

}]);